import React, { useEffect, useState } from 'react'
import Common_Images_Transport from '../../../common/common_imges_transport/Common_Images_Transport'
import { Get_Faqs } from '../../../../api/global/Global';

const Home_Faqs_Section = () => {
    // State to track the active accordion
    const [activeIndex, setActiveIndex] = useState(0);
    const [is_loading, set_Is_Loading] = useState(false);
    const [get_faqs_list, set_Get_Faqs_List] = useState([])

    const Hnadle_Get_Faqs = async () => {
        set_Is_Loading(true)
        try {
            const response = await Get_Faqs();
            set_Get_Faqs_List(response?.data?.data?.faq);
            if (response?.data?.status == "200") {
                set_Is_Loading(false)
            }
            else if (response?.response?.data?.status == "500") {
                set_Is_Loading(false)
            }
        }
        catch (error) {
            set_Is_Loading(false)
        }
    }

    // Function to handle accordion toggle
    const toggleAccordion = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    useEffect(() => {
        Hnadle_Get_Faqs();
    }, [])

    return (
        <div>
            <section className="gi-faq pb-[40px] max-[767px]:pb-[30px]">
                <div
                    className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1220px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                    <div
                        className="section-title-2 w-full mb-[20px] pb-[20px] flex flex-col justify-center text-center px-[12px] items-center">
                        <h2
                            className="bodonibook_font text-3xl text-gray-900 font-bold capitalize">
                            FAQ'S About Astrology</h2>
                        <p className="mt-[5px] text-[12px] font-semibold text-gray-900 capitalize">Why Is Astrology So Accurate?</p>
                    </div>

                    <div className="w-full flex flex-wrap">
                        <div className="min-[992px]:w-[35%] w-full px-[12px]">
                            <div className="gi-accordion style-1">
                                <div className="w-full md:pr-8">
                                    <img src={Common_Images_Transport?.faq} className="w-full rounded-lg" alt="faq_image" />
                                </div>
                            </div>
                        </div>
                        <div className="min-[992px]:w-[65%] w-full px-[12px] max-[991px]:mt-[30px]">
                            <div className="gi-accordion style-1">
                                {get_faqs_list?.map((item, index) => (
                                    <div key={index} className="border border-[#eee] rounded overflow-hidden mb-4"> {/* Added mb-4 for margin-bottom */}
                                        <h3
                                            className="gi-accordion-header py-3 px-4 bg-gray-100 text-gray-900 text-[14px] cursor-pointer font-semibold tracking-[0.01rem] flex justify-between items-center uppercase"
                                            onClick={() => toggleAccordion(index)}
                                        >
                                            {item?.title}
                                            <span className={`transform transition-transform ${activeIndex === index ? 'rotate-90' : 'rotate-0'}`}>
                                                <i class="fi-rr-angle-small-right text-xl"></i>
                                            </span>
                                        </h3>
                                        <div className={`gi-accordion-body px-4 pb-4 text-gray-800 text-[13px] leading-[24px] bg-gray-100 transition-all duration-300 ${activeIndex === index ? 'block' : 'hidden'}`}>
                                            {item?.description}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Home_Faqs_Section